<template>
  <div class="p-20">
    <van-form ref="form" :show-error="false" error-message-align="right">
      <van-cell-group>
        <van-field v-f-show="'ssbm'" input-align="right" name="ssbm" :required="isRequired('ssbm')"
                   :value="formData.ssbm" label="部门" :rules="getRules('ssbm')" placeholder="请选择部门">
          <template #input>
            <view-item @click.native="isShowPopup(ssbm,'ssbm')" :value="formData.ssbm" placeholder="请选择部门"/>
            <van-popup v-model="ssbm.show" position="bottom">
              <van-nav-bar title="选择部门" left-text="取消" right-text="确定" @click-left="ssbm.show = false"
                           @click-right="popupSubmit('ssbm',{label:'label',value:'value'})"/>
              <van-search v-model="ssbm.filterText" @input="pickerSearch($event,ssbm,'label')" clearable shape="round"/>
              <van-picker ref="ssbm" value-key="label" :columns="ssbm.filteredData" @cancel="ssbm.show = false"/>
            </van-popup>
          </template>
        </van-field>


        <van-field v-f-show="'tplx'" input-align="right" name="tplx"
                   :required="isRequired('tplx')" :rules="getRules('tplx')"
                   :value="formData.tplx" label="退票类型" placeholder="退票类型">
          <template #input>
            <view-item @click.native="isShowPopup(tplx,'tplx')" :value="formData.tplx"
                       placeholder="退票类型"/>
            <van-popup v-model="tplx.show" position="bottom">
              <van-nav-bar title="选择退票类型" left-text="取消" right-text="确定"
                           @click-left="tplx.show = false" @click-right="popupSubmit('tplx')"/>
              <van-search v-model="tplx.filterText" @input="pickerSearch($event,tplx)" clearable
                          shape="round"/>
              <van-picker ref="tplx" :columns="tplx.filteredData" @cancel="tplx.show = false"/>
            </van-popup>
          </template>
        </van-field>
        <van-field v-f-show="'sy'" v-model="formData.sy" :readonly="isDisabled('sy')" :required="isRequired('sy')"
                   name="sy" :rules="getRules('sy')" type="textarea" maxlength="200" rows="3" autosize label="事由"
                   show-word-limit placeholder="请输入事由" input-align="right"/>
        <van-field v-f-show="'bz'" v-model="formData.bz" :disabled="isDisabled('bz')" :required="isRequired('bz')"
                   :rules="getRules('bz')" name="bz" type="textarea" maxlength="200" rows="3" autosize label="备注"
                   show-word-limit placeholder="请输入备注" input-align="right"/>
        <van-field v-f-show="'fj'"  class="fileValueBox"  :value.prop="formData.fj" input-align="right" name="fj" :required="isRequired('fj')"
                   :rules="getRules('fj')" label="原始发票" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="isDisabled('fj')" :files="formData.fj" @success="uploadSuccess"
                         module-type="flow"  @fileRemove="(removedFile)=>handleFileRemove(removedFile,'formData','fj')"></uploadFiles>
          </template>
        </van-field>
      </van-cell-group>

      <div v-f-show="'relativeFlow'">
        <van-row type="flex" align="center" class="m-t-26 m-b-26">
          <van-col :span="12">
            <div class="font-32 font-weight-500 cor-00 ">关联开票流程</div>
          </van-col>
          <van-col :span="12">
            <van-button v-if="!isDisabled('relativeFlow')" icon="add-o" round native-type="button" color="#FFDA3E"
                        text="添加审批单" @click="addSpd"
                        class="width-100"/>
          </van-col>
        </van-row>
        <van-cell-group v-if="formData.relativeFlow.length === 0" class="text-center p-20">
          <img class="w-300 h-300 " :src="`${image_base_url}/null.png`"></img>
          <div class="font-24 cor-8B m-t-20">暂无关联流程，请点击“添加审批单”关联~</div>
        </van-cell-group>
        <van-cell-group v-else v-for="(item,index) in formData.relativeFlow" :key="index" class="b-r-10 m-t-20 p-20">
          <div class="flex col-center row-between">
            <!-- 标题 -->
            <div class="flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10">
              {{ item.title }}
            </div>
            <div v-f-show="'relativeFlow'" @click="removeItem(index,'relativeFlow')"
                 class="font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7">
              <img class="w-30 h-30" :src="`${image_base_url}/shoppingDel.png`"></img>
            </div>
          </div>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">流程状态</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.businessStatusName }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">申请时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.startTime ? moment(item.startTime).format('YYYY-MM-DD') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">完成时间</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30 van-multi-ellipsis--l3">
                {{ item.endTime ? moment(item.endTime).format('YYYY-MM-DD') : '' }}
              </div>
            </van-col>
          </van-row>
          <van-row type="flex" align="center" class="m-t-10">
            <van-col span="10">
              <div class="cor-88 font-30">摘要</div>
            </van-col>
            <van-col span="14">
              <div class="cor-33 font-30">
                {{ item.summary }}
              </div>
            </van-col>
          </van-row>
        </van-cell-group>
      </div>
    </van-form>
    <div class="font-32 font-weight-500 cor-00 m-t-26 m-b-26">流程</div>
    <!--      这个是不带选人的流程图    -->
    <flowTrace v-if="!$route.query.reSend && (processInstanceId || $route.query.processInstanceId)" class=""
               :actCurrentNode="processData.actCurrentNode || ''" :flowTraceList="flowTrace"
               :processInfo="processData"></flowTrace>
    <!--      这个是带选人的流程图    -->
    <approver v-else class="" ref="approver" @addUser="addUser" :processData="processData" :formData="formData"/>
    <bottom-bar @submit="submit" @mention="mention"></bottom-bar>
    <van-popup position="bottom" v-model="approver.show">
      <van-nav-bar title="选择办理人" left-text="取消" right-text="确定" @click-left="approver.show = false"
                   @click-right="approverPopupSubmit"/>
      <van-search v-model="approver.filterText" @input="treeSearch($event, $refs.approverTree)" clearable
                  shape="round"/>
      <div style="overflow-y: auto" class="h-vh-35">
        <div class="p-10">
          <el-tree ref="approverTree" @check-change="approverCheckChange($event, $refs.approverTree)" node-key="uuid"
                   check-strictly :data="approver.data" :filter-node-method="filterNode" check-on-click-node
                   show-checkbox/>
        </div>
      </div>
    </van-popup>
    <relativeFlow :show="relativeFlow.show" @finish="relativeFlowFinish" groupId="7"
                  @close="relativeFlow.show = false"></relativeFlow>
  </div>
</template>
<script>
import {getFormDataByInstanceId, getRelaveFormDataByInstanceId,} from '@/api/flow'
import {getCurrentUserDept, getDeptUserTreeAll} from '@/api/user.js'
import moment from "moment";
import mixin from '@/mixin/flow'
import cache from "@/plugins/cache";
import uploadFiles from "@/components/uploadFiles/index.vue";
import fileMixins from "@/components/uploadFiles/fileMixins";
import bottomBar from '@/components/flow/bottom-bar.vue'
import flowTrace from '@/components/flow/flowTrace.vue'
import approver from "@/components/flow/approver.vue";
import relativeFlow from '@/components/flow/relativeFlow.vue'
import account from '@/views/tripReimbursement/components/account.vue'
import {Dialog} from 'vant';

export default {
  name: 'refund_a_ticket',
  mixins: [mixin,fileMixins],
  components: {uploadFiles, bottomBar, approver, flowTrace, relativeFlow, account, Dialog,},
  data() {
    return {
      moment,
      formData: {
        flowNo: '',
        sqr: '',
        ssbm: '',
        tplx: '',
        relativeFlow: [],
        sy: '',
        bz: '',
        fj: '',
        relativeFlowId: ''
      },
      // 关联流程
      relativeFlow: {
        show: false
      },
      // 所属部门
      ssbm: {
        data: [],
        filteredData: [],
        filterText: '',
        show: false
      },
      // 选人树
      approver: {
        data: [],
        filterText: '',
        show: false
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
      tplx: {
        data: ["换开", "退票", "其他"],
        show: false,
        filteredData: ["换开", "退票", "其他"],
        filterText: '',
      },
      rules: {}
    }
  },
  created() {
    const _this = this
    const {templateId, groupId, reSend} = this.$route.query
    this.SET_TEMPLATE_ID(templateId)
    this.SET_GROUP_ID(groupId)
    this.init()
    if (reSend && this.$route.query.processInstanceId) { // 重新发起时
      this.$loading.show()
      this.getFormInfo({templateId: this.templateId}).then(res => {
        // 从后台去流程表单数据 只取fomData
        getFormDataByInstanceId(this.$route.query.processInstanceId).then(form => {
          // 合并
          Object.assign(this.formData, res.data.processTemplates.expressVals, form.data)
          this.$loading.hide()
        })
      })
    } else if (this.$route.query.processInstanceId && !this.$route.query.reSend) { // 外部跳转时
      this.SET_PROCESS_INSTANCE_ID(this.$route.query.processInstanceId)
      if (this.$route.query.taskId) {
        this.SET_TASK_ID(this.$route.query.taskId)
      }
      this.$loading.show()
      this.getProcessInfo({
        processInstanceId: this.$route.query.processInstanceId,
        taskId: this.$route.query.taskId
      }).then(res => {
        Object.assign(this.formData, res.data.formData)
        this.$loading.hide()
      })
    } else {
      console.log('新增时')
      // 新增时调用
      this.getFormInfo({templateId: this.templateId}).then(res => {
        Object.assign(this.formData, res.data.processTemplates.expressVals)
      })
      // 关联流程跳转时
      if (this.$route.query.isRelevanceFlow) {
        console.log('关联流程跳转时')
        this.formData.relativeFlowId = this.$route.query.destProcessInstanceId
        const params = {
          processInstanceId: this.$route.query.destProcessInstanceId,
          destGroupId: this.$route.query.groupId ? this.$route.query.groupId : this.$route.query.destGroupId,
        }
        getRelaveFormDataByInstanceId(params).then(res => {
          Object.assign(this.formData, res.data)
          console.log(this.formData)
        })
      }
      // 新增时 初始化的时候预定人是当前登录用户
      const currentUserInfo = JSON.parse(cache.session.get("userInfo"))
      this.formData.sqr = currentUserInfo.userId
      this.getCurrentUserDept(currentUserInfo)
    }

  },
  methods: {
    // 进页面就调用
    init() {
      // 获取部门用户树
      this.getDeptUserTreeAll()
    },
    // 获取人员所属部门列表
    getCurrentUserDept(user) {
      return new Promise(resolve => {
        getCurrentUserDept({userId: user.id || user.userId}).then(res => {
          this.ssbm.data = res.data
          // 搜索过滤
          this.ssbm.filteredData = this.ssbm.data
          // 为所属部门赋默认值
          if (this.ssbm.filteredData.length > 0) {
            this.formData.ssbm = this.ssbm.filteredData[0].value + "," + this.ssbm.filteredData[0].label
          }
          resolve(res.data)
        })
      })
    },
    _getCategoryTree(treeList) {
      // 使用箭头函数来保持对 Vue 组件实例的 this 的引用
      const processTree = (originalItems) => {
        const newItems = []; // 创建一个新数组来存储处理过的节点
        originalItems.forEach(item => {
          const newItem = {...item}; // 创建一个新对象来避免修改原始数据
          newItem.disabled = newItem.children ? true : false;
          newItem.uuid = this.uuid(); // 确保正确访问 Vue 组件实例的方法
          if (newItem.children && newItem.children.length > 0) {
            newItem.children = processTree(newItem.children); // 递归调用并更新 children
          }
          newItems.push(newItem); // 将处理过的节点添加到新数组中
        });
        return newItems; // 返回新数组
      };
      return processTree(treeList); // 启动递归处理并返回新的树列表
    },
    // 人员、部门树
    getDeptUserTreeAll() {
      const _this = this
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
          this.$set(this.approver, 'data', data)
        })
      })
    },
    removeItem(index, field) {
      //请至少保留一项
      if (this.formData[field].length === 1 && field == 'relativeFlow') return this.$toast('请至少保留一项')
      this.$dialog.confirm({
        message: '确定删除该项吗？',
      }).then(() => {
        this.formData[field].splice(index, 1)
        if (field === 'zffsmxb') {
          this.changeZffsmxb()
        }
      })
    },
    uploadSuccess(fileList) { // 每次都会filelist全部丢出来
      this.formData.fj = fileList
    },
    addSpd() {
      this.relativeFlow.show = true
    },
    relativeFlowFinish(data) {
      // 循环遍历this.formData.relativeFlow，添加data中不重复的项目
      data.forEach(item => {
        if (!this.formData.relativeFlow.find(ele => ele.flowNo === item.flowNo)) {
          this.formData.relativeFlow.push(item)
        }
      })
      // this.formData.relativeFlow = data
      this.relativeFlow.show = false
    },
  }
}
</script>
